// removed by extract-text-webpack-plugin
module.exports = {"team_logo":"pointstable_team_logo_38_m8","team_stand":"pointstable_team_stand_rA2fH","left_info":"pointstable_left_info_w5gfo","right_info":"pointstable_right_info_2FxMY","team_container":"pointstable_team_container_piFhL","team_cell":"pointstable_team_cell_3AyQT","team_name":"pointstable_team_name_2bJ5V","team_wins":"pointstable_team_wins_2gT8Z","team_draws":"pointstable_team_draws_3higg","team_defeat":"pointstable_team_defeat_1BVUi","team_points":"pointstable_team_points_2n9UD","pheader":"pointstable_pheader_1-xF7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pointstable/pointstable.css
// module id = 338
// module chunks = 0